import { api } from '@/services/api';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { GET_TENANT_TAXONOMY_QUERY_KEY } from './useGetTenantTaxonomy';
import { TAXONOMY_CHILDREN_QUERY_KEY } from './useGetTaxonomyChildren';

export const useDeleteTaxonomy = () => {
  const queryClient = useQueryClient();
  const { getTenantId } = useTenants();
  const tenantId = getTenantId();

  const { mutate, isPending, error } = useMutation({
    mutationFn: (taxonomyId: string) => api.taxonomy.deleteTaxonomy(tenantId, taxonomyId),
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: [GET_TENANT_TAXONOMY_QUERY_KEY],
      });
      queryClient.removeQueries({
        queryKey: [TAXONOMY_CHILDREN_QUERY_KEY],
      });
    },
  });

  return {
    deleteTaxonomy: mutate,
    isDeleting: isPending,
    deleteError: getApiError(error),
  };
};
